import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { RouterParams } from '../../../../app/shared/interfaces';
import Breadcrumbs, { BreadcrumbsItem } from '../../../../template/MainTheme/components/Breadcrumbs';
import DefaultCard from '../../../../components/default/DefaultCard';
import LazyLoading from '../../../../components/LazyLoading';
import { ServiceResponse } from '../../../../app/services/shared/interfaces';
import { Tabs, Tab } from 'react-bootstrap';
import PurchaseDocumentDetailContainer from '../PurchaseDocumentDetailContainer';
import useNavigationPage from '../../../../hooks/useNavigationPage';
import { PurchaseDocumentDetail, PurchaseDocumentDetailFilters } from '../../../../app/models/PurchaseDocumentDetail';
import usePurchaseDocumentHistoryService from '../../../../app/services/hooks/usePurchaseDocumentHistoryService';
import { PurchaseDocumentHistoryDataForm, PurchaseDocumentHistoryFilters } from '../../../../app/models/PurchaseDocumentHistory';
import { PaymentStatusDataForm, PaymentStatusesStatus } from '../../../../app/models/PaymentStatus';
import { PurchaseDocumentStatus } from '../../../../app/models/PurchaseDocumentStatus';
import usePurchaseDocumentService from '../../../../app/services/hooks/usePurchaseDocumentService';
import { PurchaseDocumentDataForm, PurchaseDocumentFilters } from '../../../../app/models/PurchaseDocument';
import usePurchaseDocumentDetailService from '../../../../app/services/hooks/usePurchaseDocumentDetailService';
import PurchaseDocumentHistoryContainer from '../PurchaseDocumentHistoryContainer';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const PurchaseDocumentEdit = ({ onSaved, onCancel, onError }: Props) => {
    const { id } = useParams<RouterParams>();

    const { navigationPage } = useNavigationPage();
    const { editPurchaseDocument, showPurchaseDocument} = usePurchaseDocumentService();
    const { getAllPurchaseDocumentHistoriesByInvoice} = usePurchaseDocumentHistoryService();
    const [verifyingPurchaseDocument, setVerifyingPurchaseDocument] = useState<boolean>(true);
    const {getPurchaseDocumentDetailsByPurchaseDocument} = usePurchaseDocumentDetailService(); 
    const [purchaseDocument, setPurchaseDocument] = useState<PurchaseDocumentDataForm>({});
    const [purchaseDocumentForm, setPurchaseDocumentForm] = useState<PurchaseDocumentDataForm>({});
    const [paymentStatuses, setPaymentStatuses] = useState<PaymentStatusDataForm[]>([]);
    const [paymentStatusesStatus, setPaymentStatusesStatus] = useState<PaymentStatusesStatus[]>([]);
    const [statuses, setStatuses] = useState<PurchaseDocumentStatus[]>([]);
    const [purchaseDocumentHistory, setPurchaseDocumentHistory] = useState<PurchaseDocumentHistoryDataForm[]>([]);
    const [purchaseDocumentsDetail, setPurchaseDocumentsDetail] = useState<PurchaseDocumentDetail[]>([]);
    const [totalRowsDetail, setTotalRowsDetail] = useState<number>(0);
    const [totalHistoryRows, setTotalHistoryRows] = useState<number>(0);
    const [filter] = useState<PurchaseDocumentFilters>({
        page: 1,
        per_page: 10,
        sort: 'position',
        order: 'desc'
    });
    const [filterDetails, setFilterDetails] = useState<PurchaseDocumentDetailFilters>({
        page: 1,
        per_page: 10,
        sort: 'position',
        order: 'desc'
    });
    const [filterHistory, setFilterHistory]= useState<PurchaseDocumentHistoryFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'desc'
    });

    useEffect(() => {
        // reloadModule();
        showDetails();
        edit(parseInt(id));
    }, [id]);


    useEffect(() => {
        reloadPurchaseDocumentDetailTable();
    }, [filterDetails]);

    useEffect(() => {
        reloadTableHistory();
    }, [filterHistory]);

    const [errorFields, setErrorFields] = useState<any>();


    const edit = (id: number) => {
        editPurchaseDocument(id, {
            onSuccess: (response: ServiceResponse) => {
                setPurchaseDocument(response.data.purchase_document);
                setVerifyingPurchaseDocument(false)
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
                if (response.data.to_dashboard) {
                    navigationPage('/purchase-documents');
                }
            }
        });
    };


    const showDetails = () => {
        showPurchaseDocument(Number(id), {
            onSuccess: (response: ServiceResponse) => {
                setPurchaseDocumentForm(response.data.purchase_document);
                setStatuses(response.data.statuses);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        });
    };

    const reloadTableHistory = () => {
        getAllPurchaseDocumentHistoriesByInvoice(Number(id),filterHistory, {
            onSuccess: (response: ServiceResponse) => {
                setPurchaseDocumentHistory(response.data.purchase_document_histories);
                setTotalHistoryRows(response.data.total_rows);
                },
                onError: (response: ServiceResponse) => {
                    toast.error(response.message, {
                        autoClose: 2500
                    });
                }
            
        });
    };


    const reloadPurchaseDocumentDetailTable = () => {
        getPurchaseDocumentDetailsByPurchaseDocument(filter, Number(id), {
            onSuccess: (response: ServiceResponse) => {
                setPurchaseDocumentsDetail(response.data.purchase_document_details);
                setPaymentStatuses(response.data.service_manifest_detail);
                setPaymentStatusesStatus(response.data.statuses)
                setTotalRowsDetail(response.data.total_rows);

            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };


    if (verifyingPurchaseDocument) {
        return (
            <DefaultCard>
                <LazyLoading height={300} />
            </DefaultCard>
        );
    }

    const breadcrumbs: BreadcrumbsItem[] = [
        { name: 'Documentos de venta', url: '/purchase-documents', isActive: false },
        { name: `Editar ${purchaseDocumentForm.document_type_obj?.name} #${purchaseDocument.document_number}`, url: `/purchase-documents/${id}/edit`, isActive: true }
    ];


    return (
        <>
            <Breadcrumbs pageSection={`Editar ${purchaseDocumentForm.document_type_obj?.name}  #${purchaseDocument.document_number}`} breadcrumbs={breadcrumbs} />

            <Tabs defaultActiveKey="general-data" id="purchase-document-tabs" className="mb-3">
                <Tab eventKey="general-data" title="Datos Generales">
                    <div className="row">
                        {/* Tabla de detalles de la factura */}
                        <div className="col-12">
                            <PurchaseDocumentDetailContainer
                                purchaseDocumentId={parseInt(id)}
                                purchaseDocument={purchaseDocument}
                                setPurchaseDocument={setPurchaseDocument}
                                purchaseDocumentForm={purchaseDocumentForm}
                                setPurchaseDocumentForm={setPurchaseDocumentForm}
                                setPurchaseDocumentDetailTable={setPurchaseDocumentsDetail}
                                setPurchaseDocumentHistoryTable={setPurchaseDocumentHistory}
                                reloadPurchaseDocumentDetailTable={reloadPurchaseDocumentDetailTable}
                                reloadPurchaseDocument={edit}
                                filterDetail={filterDetails}
                                setFilterDetail={setFilterDetails}
                                filterHistory={filterHistory}
                                setFilterHistory={setFilterHistory}
                                reloadHistoryTable={reloadTableHistory}
                                reloadDetail={showDetails}
                                paymentStatuses={paymentStatuses}
                                setPaymentStatusesStatus={setPaymentStatusesStatus}
                                paymentStatusesStatus={paymentStatusesStatus}
                                statuses={statuses}
                                setStatuses={setStatuses}
                                totalRowsDetail={totalRowsDetail}
                            />
                        </div>
                    </div>
                </Tab>

                <Tab eventKey="history" title="Historial">
                    <div className="col-12">
                            <PurchaseDocumentHistoryContainer
                                purchaseDocumentId={parseInt(id)}
                                purchaseDocumentHistory={purchaseDocumentHistory}
                                totalRowsHistory={totalHistoryRows}
                                filterHistory={filterHistory}
                                setFilterHistory={setFilterHistory}
                                setPurchaseDocumentHistoryTable={setPurchaseDocumentHistory}
                                reloadPurchaseDocumentHistoryTable={reloadTableHistory}
                            />

                    </div>
                </Tab>
            </Tabs>

        </>
    );
};

export default PurchaseDocumentEdit;
